import { useHistory, useLocation } from "react-router-dom";
import {
  NotificationScreens,
  WorkspaceType,
  Notification,
  EnvType,
} from "@shared/types";
import useSharedWorkspace from "@shared/features/workspaces/useSharedWorkspace";
import { TRADE_EXTRA_DETAILS_TABS } from "@shared/common/constants";
import {
  getAccountExtraDetailsRoute,
  getBotExtraDetailsRoute,
  getTradeExtraDetailsRoute,
} from "utils/routes.tsx";
import { BotExtraDetailsTabs } from "@shared/features/bots/types";
import { BILLING_SETTINGS_PATH, MY_GROUPS_PATH } from "common/constants";

export const useNotificationNavigation = () => {
  const location = useLocation();
  const history = useHistory();

  const { workspace, setWorkspaceType } = useSharedWorkspace({
    allowAdminWorkspace: true,
  });
  const isDemo = workspace === WorkspaceType.DEMO;
  const isUser = workspace === WorkspaceType.USER;

  const openExtraDetailsDrawer = (
    notification: Notification,
    getExtraDetailsRoute: (
      location: string,
      id: number,
      tab?: string
    ) => string,
    tabNames?: string[]
  ) => {
    const tab =
      tabNames?.[
        notification?.tab_number !== null ? notification?.tab_number : 0
      ];

    const notificationIsDemo = notification.env_type === EnvType.DEMO;
    if ((notificationIsDemo && !isDemo) || (!notificationIsDemo && !isUser)) {
      setWorkspaceType(
        notificationIsDemo ? WorkspaceType.DEMO : WorkspaceType.USER
      );
    }
    const baseUrl =
      location.pathname && location.pathname !== "/"
        ? location.pathname
        : "/dashboard";
    history.push(getExtraDetailsRoute(baseUrl, notification.component_id, tab));
  };

  const navigateFromNotification = (notification: Notification) => {
    const screen = notification?.screen;
    if (screen === NotificationScreens.TRADE_DETAIL) {
      openExtraDetailsDrawer(
        notification,
        getTradeExtraDetailsRoute,
        Object.values(TRADE_EXTRA_DETAILS_TABS)
      );
    } else if (
      screen === NotificationScreens.ACCOUNT_FORM ||
      screen === NotificationScreens.ACCOUNT_DETAIL
    ) {
      openExtraDetailsDrawer(notification, getAccountExtraDetailsRoute);
    } else if (screen === NotificationScreens.BOT_DETAIL) {
      openExtraDetailsDrawer(
        notification,
        getBotExtraDetailsRoute,
        Object.values(BotExtraDetailsTabs)
      );
    } else if (screen === NotificationScreens.GROUPS) {
      history.push(MY_GROUPS_PATH);
    } else if (screen === NotificationScreens.SUBSCRIPTION) {
      history.push(BILLING_SETTINGS_PATH);
    }
  };

  return {
    navigateFromNotification,
  };
};
